<div class="np-row" data-testid="nav-plan-row-container">
  <div class="np-pill">
    <img class="np-pill-icon"
      [src]="computer ? computer.Icon : '/assets/icons/' + settingsService.getMap().Skin + '/ui/target_icon.svg'" alt="target" />
    @if (computer?.BatteryReservedWarning) {
      <button type="button" class="battery-reserved-warning-icon ev-plain-button" (click)="openWarning($event)" data-testid="nav-plan-row-warning-btn">!</button>
    }

    @if (computer) {
      <div class="np-pill-value">
        <div [hidden]="!showMetricKMeter(computer.DistToDest)">
          <span class="np-num">{{ computer.DistToDest / 1000 | turnValueIntegerThousands }}</span>
          <span class="np-unit">km</span>
        </div>
        <div [hidden]="!showMetricMeter(computer.DistToDest)">
          <span class="np-num">{{ computer.DistToDest | turnValueInteger }}</span>
          <span class="np-unit">m</span>
        </div>
        <div [hidden]="!showImperialMile(computer.DistToDest)">
          <span class="np-num">{{ computer.DistToDest * 0.000621371192 | turnValueIntegerThousands }}</span>
          <span class="np-unit">mi</span>
        </div>
        <div [hidden]="!showImperialYard(computer.DistToDest)">
          <span class="np-num">{{ computer.DistToDest * 1.0936133 | turnValueInteger }}</span>
          <span class="np-unit">yd</span>
        </div>
      </div>
    }
    @if (!computer) {
      <span class="np-pill-value np-placeholder">--</span>
    }
  </div>

  <div class="np-pill">
    <img class="np-pill-icon"
      [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/computer_icon_clock.svg'" alt="time" />
    <span class="np-pill-value" [ngClass]="{ 'np-placeholder': !computer }">{{ computer?.TimeToDest || '--' }}</span>
  </div>
</div>
